import React, { useContext, useEffect, useState } from 'react'
import { Editor } from "react-draft-wysiwyg";
import { EditorState, ContentState, convertToRaw } from 'draft-js';
import draftToHtml from "draftjs-to-html"
import htmlToDraft from 'html-to-draftjs';
import parse from 'html-react-parser';
import "react-draft-wysiwyg/dist/react-draft-wysiwyg.css";
import { useLocation, useNavigate } from 'react-router-dom';
import Header from '../header/Header';
import { editTemplate, editTemplateApproval, resetEditTemplateApprovalDetailsState, resetEditTemplateState, resetSaveTemplateState, saveTemplate } from '../../redux/features/template/templateSlice';
import { Spinner } from 'react-bootstrap';
import { useDispatch, useSelector } from 'react-redux';
import useToast from '../../shared/Toast';
import AppContext from '../../storage/AppContext';

const EditTemplate = () => {
    const [title,setTitle] = useState("");
    const [titleError,setTitleError] = useState(false)

    const [editorState, setEditorState] = useState(EditorState.createEmpty())
    const [editedHTMLContent,setEditedHTMLContent] = useState('')
    const [contentError, setConentError] = useState(false)

    const navigate = useNavigate()
    const showToast = useToast()
    const dispatch = useDispatch()
    const templateDetails = useLocation()?.state;
    const editTemplateDetails = useSelector((state) => state.template.editTemplateDetails)
    const editTemplateApprovalDetails = useSelector(state => state.template.editTemplateApprovalDetails)

    const appContext = useContext(AppContext);
    const userDetails = appContext?.userDetails

    useEffect(() => {
        if(templateDetails){
            const contentBlock = htmlToDraft(templateDetails?.message);
            const contentState = ContentState.createFromBlockArray(contentBlock.contentBlocks);
            setEditorState(EditorState.createWithContent(contentState))
            setTitle(templateDetails?.title)
        }
    },[])

    useEffect(() => {
        if(editTemplateDetails.status === 'succeeded'){
            navigate('/templates',{replace : true})
            resetState()
            dispatch(resetEditTemplateState())
            showToast({ message: editTemplateDetails.message })
        }
        if(editTemplateDetails.status === "failed"){
            dispatch(resetEditTemplateState())
            showToast({message: editTemplateDetails.message, type: 'error'})
        }
    },[editTemplateDetails])

    useEffect(() => {
        if(editTemplateApprovalDetails.status === 'succeeded'){
            navigate('/templates',{replace : true})
            resetState()
            dispatch(resetEditTemplateApprovalDetailsState())
            showToast({ message: editTemplateApprovalDetails.message })
        }
        if(editTemplateApprovalDetails.status === "failed"){
            dispatch(resetEditTemplateApprovalDetailsState())
            showToast({message: editTemplateApprovalDetails.message, type: 'error'})
        }
    },[editTemplateApprovalDetails])

    useEffect(() => {
        convertContentToHTML()
    },[editorState])

    const handleEditorChange = (e) => {
        setEditorState(e);
    }

    const convertContentToHTML = () => {
        const rawContentState = convertToRaw(editorState.getCurrentContent());
        const currentContentAsHTML = draftToHtml(rawContentState);
        setEditedHTMLContent(currentContentAsHTML);
    }

    const resetState = () => {
        setTitle('')
        setEditorState(EditorState.createEmpty())
        setTitleError(false)
        setConentError(false)
    }

    const onClickCancel = () => {
        resetState()
        navigate('/templates',{replace : true})
    }

    const onClickSave = () => {
        const rawContentState = convertToRaw(editorState.getCurrentContent());
        if(!title){
            setTitleError(true)
        }else if(rawContentState?.blocks?.filter(eachBlock => eachBlock?.text !== "").length === 0 && Object.keys(rawContentState?.entityMap).length === 0){
            setConentError(true)
            setTitleError(false)
        }else{
            const templateData = {title, message:editedHTMLContent, id:templateDetails?._id, branch: userDetails?.data?.branch}
            dispatch(editTemplate(templateData))
        }
    }

    const onClickSendForApproval = () => {
        const rawContentState = convertToRaw(editorState.getCurrentContent());
        if(!title){
            setTitleError(true)
        }else if(rawContentState?.blocks?.filter(eachBlock => eachBlock?.text !== "").length === 0 && Object.keys(rawContentState?.entityMap).length === 0){
            setConentError(true)
            setTitleError(false)
        }else{
            const templateData = {title, message:editedHTMLContent, id:templateDetails?._id, branch: userDetails?.data?.branch, role: userDetails?.data?.role}
            dispatch(editTemplateApproval(templateData))
        }
    }


  return (
    <>
    <Header />
    {editTemplateDetails.status === 'loading' ? (<div style={{ minHeight: '80vh' }} className='d-flex justify-content-center align-items-center'><Spinner animation="border" role="status"></Spinner></div>) :
    <div className='px-4 mt-2'>
        <div className="form-group">
            <label className="control-label" htmlFor="title">Enter Title</label>
            <input value={title} onChange={(event) => {setTitle(event.target.value)}} placeholder='Enter Title' autoComplete='off' className="form-control" id='title' name='title' required />
            {titleError && <p style={{color:'red'}}>Please Enter Title</p>}
        </div>
        <div className="form-group">
            <label className="control-label" htmlFor="message">Enter Message</label>
            <Editor
                name="message"
                wrapperStyle={{border:'1px solid #d6d6d6'}}
                editorStyle={{paddingLeft:'20px',paddingRight:'20px'}}
                editorState={editorState}
                onEditorStateChange={handleEditorChange}
            />
            {contentError && <p style={{color:'red'}}>Please Enter Message</p>}
        </div>
        <div className='d-flex justify-content-end'>
            <button className='btn btn-secondary mr-2' onClick={onClickCancel}>Cancel</button>
            {userDetails?.data?.role === 'Admin' ?<button className='btn btn-primary' onClick={onClickSave}>Save</button>:<button className='btn btn-primary' onClick={onClickSendForApproval}>Send For Approval</button>}
        </div>
    </div>}
    </>
  )
}

export default EditTemplate